import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77dea11a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "share" }
const _hoisted_2 = { class: "share-popup-top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Facebook", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Twitter", -1))
const _hoisted_5 = { class: "" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Copy Link", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _directive_clipboard = _resolveDirective("clipboard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popup, {
      show: $setup.showShare,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (($setup.showShare) = $event)),
      position: "bottom",
      round: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.shareCon(2)))
          }, [
            _createVNode(_component_van_icon, {
              size: "36",
              name: 'https://image.kilimall.com/kenya/new_wap/share/facebook_icon.png'.webpFilters()

            }, null, 8, ["name"]),
            _hoisted_3
          ]),
          _createElementVNode("div", {
            class: "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.shareCon(3)))
          }, [
            _createVNode(_component_van_icon, {
              size: "36",
              name: 'https://image.kilimall.com/kenya/new_wap/share/twitter_icon.png'.webpFilters()

            }, null, 8, ["name"]),
            _hoisted_4
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_van_icon, {
              size: "36",
              name: 'https://image.kilimall.com/kenya/new_wap/share/copy_icon.png'.webpFilters()

            }, null, 8, ["name"]),
            _hoisted_6
          ])), [
            [_directive_clipboard, $setup.copy_cont, "copy"],
            [_directive_clipboard, $setup.onSuccess, "success"],
            [_directive_clipboard, $setup.onError, "error"]
          ])
        ]),
        _createElementVNode("div", {
          class: "share-popup-bottom",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.close && $setup.close(...args)))
        }, " Cancel ")
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}